module.exports = __webpack_public_path__ + "media/images/emblems/Schwerzenbach-blazon-c7fb9e30b0186bd9caeecf9900713ea7.svg";